import { Component } from 'react';
import React from 'react';
import { connect } from 'react-redux';
import * as RefData from './refData'
import MapView from './mapView';

class ViewPublicidad extends Component {
  state = {
    data: this.props.operData,
    editable: this.props.session.user.permitions.map(p => p.rol).includes('ADMIN')
  }

  updateData(key, value) {
    if (!this.state.editable) return
    this.setState({
      data: {
        ...this.state.data,
        [key]: value
      }
    })
  }

  textInput(props) {
    const data = this.state.data
    return (
      <div className={props.width ? `line line-${props.width}` : 'line line-33'}>
        <label>{props.label}</label>
        <div className="div-input-form">
          <input
            type={props.type ?? 'text'}
            value={data[props.key]}
            disabled={!this.state.editable}
            onChange={(e) => this.updateData(props.key, e.target.value)}
          />
        </div>
      </div>
    )
  }

  selectInput(props) {
    const data = this.state.data
    return (
      <div className='line line-33'>
        <label>{props.label}</label>
        <div className="div-input-form">
          <select defaultValue={0} value={data[props.key]} disabled={!this.state.editable} onChange={(e) => this.updateData(props.key, e.target.value)} >
            <option value={0} disabled={true}>--</option>
            {
              props.keyRef.map(r => <option value={r.id} key={r.id}>{r.name}</option>)
            }
          </select>
        </div>
      </div>
    )
  }

  switchInput(props) {
    const data = this.state.data
    return (
      <div className='line line-33'>
        <label >{props.label}</label>
        <div className='flex-center'>
          {
            data[props.key] ?
              <span onClick={() => this.updateData(props.key, false)} className='far fa-check-square primary-color' style={{ fontSize: '27px' }}></span>
              : <span onClick={() => this.updateData(props.key, true)} className='far fa-square' style={{ fontSize: '27px', color: 'rgba(0,0,0,0.6' }}></span>
          }
        </div>
      </div>
    )
  }

  checkInput(props) {
    const data = this.state.data
    return (
      <div className='line line-100'>
        <label >{props.label}</label>
        <div className=''>
          {
            props.keyRef.map(k =>
              <div className='line line-33' style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'space-evenly' }} key={k.id}>
                <label >
                  {k.name}
                </label>
                {
                  data[props.key].includes(k.id) ?
                    <span onClick={() => this.updateData(props.key, data[props.key].filter(f => f !== k.id))} className='far fa-check-square primary-color' style={{ fontSize: '27px' }}></span>
                    : <span onClick={() => this.updateData(props.key, [...data[props.key], k.id])} className='far fa-square' style={{ fontSize: '27px', color: 'rgba(0,0,0,0.6' }}></span>
                }
              </div>
            )
          }
        </div>
      </div >
    )
  }

  render() {
    const { operData, ...data } = this.props
    return (
      <>
        <div style={{ minHeight: '205px' }}>
          <div className='modal-title-header'>
            <div className='title-modal-kml-input no-select'>Publicidad Visual</div>
            <div className='add-button'><i className="fas fa-times on-mouse-hover" onClick={data.close}></i></div>
          </div>
          <div className="points-content data-qr">
            <div className='request-image-list div-input-form' style={{ maxWidth: '870px' }}>
              {
                operData.citizenFiles.map(i =>
                  <img key={`i-${i.id}`} src={i.url} alt={i.name} />
                )
              }
            </div>
            <p><span>Proyectó: </span>{`${operData.user.nombres ?? ''} ${operData.user.apellidos ?? ''}`}</p>
            {operData.now && <p><span>Fecha: </span>{operData.now.split('T')[0]}</p>}

            <div className="content-line">
              {this.selectInput({ key: 'refComunaId', label: 'Localidad', keyRef: RefData.comunas })}
              {this.selectInput({ key: 'refBarrioId', label: 'Barrio', keyRef: RefData.barrios.filter(f => f.refComunaId === parseInt(this.state.data.refComunaId)).sort((a, b) => a.name.localeCompare(b.name)) })}
              {this.textInput({ key: 'address', label: 'Dirección' })}
              {this.textInput({ key: 'lat', label: 'Latitud', disabled: true })}
              {this.textInput({ key: 'lng', label: 'Longitud', disabled: true })}
              <MapView data={this.state.data} onChange={(key, val) => this.updateData(key, val)} />
              {this.textInput({ key: 'shop', label: 'Estableciminento' })}
              {this.selectInput({ key: 'refTypeVisAdvId', label: 'Tipo de establecimiento', keyRef: RefData.advType })}
              {this.textInput({ key: 'owner', label: 'Propietario' })}
              {this.selectInput({ key: 'refDocTypeId', label: 'Tipo de documento', keyRef: RefData.docType })}
              {this.textInput({ key: 'docNumber', label: 'Número de documento' })}
              {this.textInput({ key: 'phone', label: 'Número de contacto' })}
              {this.textInput({ key: 'email', label: 'Correo electrónico' })}
              {this.textInput({ key: 'front', label: 'Ancho', type: 'number' })}
              {this.textInput({ key: 'deep', label: 'Alto', type: 'number' })}
              <div className='line line-33'>
                <label>Cálculo</label>
                <div className="div-input-form">
                  <input
                    value={parseFloat(this.state.data.front) * parseFloat(this.state.data.deep)}
                    disabled={true}
                  />
                </div>
              </div>
              {this.switchInput({ key: 'isLegal', label: 'Anuncio legalizado' })}
              {this.textInput({ key: 'obs', label: 'Observaciones', width: '100' })}
            </div>
            <div className='line line-100' style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <div className="button-secondary line line-20 text-center">
                <div className="div-input-button">
                  <input type="button" value="Cerrar" onClick={data.close} />
                </div>
              </div>
              {
                this.props.session.user.permitions.map(p => p.rol).includes('ADMIN') &&
                <div className="button-primary line line-20 text-center">
                  <div className="div-input-button" style={{ backgroundColor: 'var(--primary-color)' }}>
                    <input
                      type="button" value="Guardar"
                      style={{ backgroundColor: 'var(--primary-color)', color: 'white' }}
                      onClick={() => this.props.onSave(this.state.data)}
                    />
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
      </>
    )
  }
}

function mapStateToProps(state) {
  return {
    session: state.session
  }
}

export default connect(mapStateToProps)(ViewPublicidad);